import React from 'react';
import { Skeletons } from 'ui/components/skeleton';
import { formatDate, currencyFormat } from 'utilities/common';
import { useHistory } from 'react-router-dom';

const CardWillToLater = ({ isLoading, data }) => {
  const History = useHistory();

  return isLoading ? (
    <div className="card p-3 rounded-2 bg-white">
      <Skeletons height="400px" />
    </div>
  ) : (
    <div className="card p-3 rounded-2 bg-white mb-3 mb-md-0">
      <h3 className="card-title dx-card-title border-bottom pb-2">
        Receivable Akan Terlambat (1 - 5 Hari Lagi)
      </h3>
      <div className="feature-listing">
        <div className="table-responsive m-0 table-overflow">
          <table
            className="table table-hover table-vcenter card-table datatable"
            width="100%"
          >
            <tbody>
              {data?.map((row, i) => (
                <tr
                  key={i}
                  onClick={() => History.push(`/receivable/${row?.id}`)}
                >
                  <td width={150}>
                    <div className="table-col">
                      <div className="text-ellipsis fs-8 fw-semibold">
                        {row?.code}
                      </div>
                      <small className="info text-uppercase">
                        TG: {formatDate(row?.schedule_at, 'YYYYMM')}
                      </small>
                      <small className="info text-uppercase">
                        DUE: {formatDate(row?.due_at, 'YYYY-MM-DD')}
                      </small>
                    </div>
                  </td>
                  <td width={250}>
                    <div className="table-col">
                      <div className="text-ellipsis fs-9 fw-semibold">
                        {row?.customer?.company_name !== '' ? `${row?.customer?.company_name} - ${row?.customer?.name}` : row?.customer?.name}
                      </div>
                      <small className="info text-uppercase">
                        {row?.project?.name}
                      </small>
                    </div>
                  </td>
                  <td width={150}>
                    <div className="table-col">
                      <div className="text-ellipsis fs-8 fw-semibold">
                        {currencyFormat(row?.total_charges)}
                      </div>
                    </div>
                  </td>
                  <td width={150}>
                    <span
                        className={`badge status-${row?.document_status}-lt ms-auto `}
                      >
                        {row?.document_status
                          ?.replace('_', ' ')
                          ?.replace('console', 'transit')}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CardWillToLater;
